var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRewards = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 .857C18.155.857 23.144 5.846 23.144 12s-4.989 11.143-11.142 11.143C5.846 23.143.858 18.154.858 12S5.846.857 12 .857m0 1.714a9.429 9.429 0 1 0 0 18.858A9.429 9.429 0 0 0 12 2.57"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.573 6.278c.45-1.382 2.404-1.382 2.854 0l.843 2.597h2.731c1.453 0 2.057 1.86.882 2.713l-2.21 1.606.844 2.597c.45 1.382-1.132 2.53-2.308 1.677L12 15.863l-2.208 1.605c-1.176.854-2.758-.295-2.309-1.677l.844-2.597-2.209-1.606c-1.175-.854-.571-2.713.882-2.713h2.73zM12 7.712l-.626 1.926a1.5 1.5 0 0 1-1.427 1.037H7.922l1.639 1.19a1.5 1.5 0 0 1 .544 1.677L9.48 15.47l1.638-1.19a1.5 1.5 0 0 1 1.764 0l1.638 1.19-.626-1.927a1.5 1.5 0 0 1 .545-1.676l1.639-1.191h-2.026a1.5 1.5 0 0 1-1.426-1.037z"
}))));
export default SvgRewards;